module.exports = __webpack_public_path__ + "media/images/Cata-1-ab8d209f9a088fb95ee6b65a813cd283.jpg";